<form [formGroup]="senderInfoForm" class="form">
  <glxy-form-field>
    <glxy-label>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.NAME' | translate }}</glxy-label>
    <input type="text" matInput formControlName="senderName" autocomplete="off" />
    <glxy-error *ngIf="senderInfoForm.get('senderName').invalid && senderInfoForm.touched">
      {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.NAME_REQUIRED' | translate }}
    </glxy-error>
  </glxy-form-field>

  <glxy-form-field>
    <glxy-label>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.SENDER_DOMAIN' | translate }}</glxy-label>
    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" formControlName="useOwn">
      <mat-radio-button [value]="false">
        {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.USE_DEFAULT' | translate }}
      </mat-radio-button>
      <ng-container *ngIf="useOwn === false; then usernameinput"></ng-container>
      <mat-radio-button [value]="true">
        {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.USE_OWN' | translate }}
      </mat-radio-button>
      <ng-container *ngIf="useOwn === true; then usernameinput"></ng-container>
    </mat-radio-group>
  </glxy-form-field>

  <glxy-form-field [bottomSpacing]="false">
    <glxy-label>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.REPLY_ADDRESS' | translate }}</glxy-label>
    <input type="text" matInput formControlName="replyTo" autocomplete="off" />
    <glxy-error *ngIf="senderInfoForm.get('replyTo').invalid && senderInfoForm.touched">
      {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.REPLY_ADDRESS_NOT_VALID' | translate }}
    </glxy-error>
  </glxy-form-field>

  <ng-template #cta>
    <glxy-empty-state>
      <p>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.EMPTY_DOMAIN' | translate }}</p>
      <glxy-empty-state-actions>
        <button *ngIf="(domains$ | async)?.length > 0" mat-raised-button (click)="openChooseDomainDialog()">
          <span>{{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.CHOOSE_DOMAIN' | translate }}</span>
        </button>
        <button *ngIf="(domains$ | async)?.length === 0" mat-raised-button (click)="handleAuthorizeDomain()">
          {{ 'DOMAIN_AUTHORIZATION.SENDER_INFO_FORM.ADD_DOMAIN' | translate }}
        </button>
      </glxy-empty-state-actions>
    </glxy-empty-state>
  </ng-template>

  <ng-template #usernameinput>
    <div class="email" *ngIf="selectedDomain?.canUse; else cta">
      <glxy-form-field [bottomSpacing]="false">
        <email-username-input
          [domain]="selectedDomain?.domain"
          [sender]="sender"
          [form]="senderInfoForm"
          (authorizeRequested)="handleAuthorizeDomain()"
          (domainChangeRequested)="this.domainChangeRequested.emit($event)"
          (invalidDomainChangeRequested)="this.invalidDomainChangeRequested.emit($event)"
          formControlNameString="senderEmailUsername"
        ></email-username-input>
      </glxy-form-field>
    </div>
  </ng-template>
</form>
